export default __webpack_public_path__ + "static/media/fehlender-hoecker.42cf611c.png";